import { render, staticRenderFns } from "./PageManagement.vue?vue&type=template&id=2ab131d1&scoped=true"
import script from "./PageManagement.vue?vue&type=script&lang=js"
export * from "./PageManagement.vue?vue&type=script&lang=js"
import style0 from "./PageManagement.vue?vue&type=style&index=0&id=2ab131d1&prod&lang=scss"
import style1 from "./PageManagement.vue?vue&type=style&index=1&id=2ab131d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab131d1",
  null
  
)

export default component.exports